<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('projects')">
      <project-action-button @open-modal="openModal" />
    </app-page-top-section>

    <!-- Search & Filter -->
    <div class="mb-3 d-flex gap-2 flex-wrap">
      <input
        type="text"
        v-model="search"
        @input="fetchProjects"
        placeholder="Search by title"
        class="form-control"
      />

      <select v-model="filterPlan" @change="fetchProjects" class="form-select">
        <option value="">All Plans</option>
        <option value="monthly">Monthly</option>
        <option value="yearly">Yearly</option>
        <option value="one-time">One-time</option>
        <option value="all">All</option>
      </select>
    </div>

    <!-- Projects Table -->
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>{{ $t('id') }}</th>
          <th>{{ $t('title') }}</th>
          <th>{{ $t('details') }}</th>
          <th>{{ $t('available_subscription_plan') }}</th>
          <th>{{ $t('documents') }}</th>
          <th>{{ $t('actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(project,index) in projects.data" :key="project.id">
          <td>{{ (projects.current_page - 1) * 10 + index + 1 }}</td>
          <td>{{ project.title }}</td>
          <td>{{ project.details }}</td>
          <td>{{ project.available_subscription_plan }}</td>
          <td>
            <div v-if="project.documents">
              <a :href="`/projects/${project.id}/download`" class="btn btn-sm btn-info">Download</a>
            </div>
            <div v-else>-</div>
          </td>
          <td>
            <button class="btn btn-sm btn-primary" @click="editProject(project)">Edit</button>
            <button class="btn btn-sm btn-danger" @click="deleteProject(project.id)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Custom Pagination -->
    <nav v-if="projects.last_page > 1">
      <ul class="pagination justify-content-center">
        <li
          class="page-item"
          :class="{ disabled: projects.current_page === 1 }"
          @click="changePage(projects.current_page - 1)"
        >
          <a class="page-link" href="#">Previous</a>
        </li>

        <li
          class="page-item"
          v-for="page in totalPages"
          :key="page"
          :class="{ active: projects.current_page === page }"
          @click="changePage(page)"
        >
          <a class="page-link" href="#">{{ page }}</a>
        </li>

        <li
          class="page-item"
          :class="{ disabled: projects.current_page === projects.last_page }"
          @click="changePage(projects.current_page + 1)"
        >
          <a class="page-link" href="#">Next</a>
        </li>
      </ul>
    </nav>

    <!-- Modal -->
    <project-form-modal
      v-if="isModalActive"
      v-model="isModalActive"
      :project="selectedProject"
      @saved="fetchProjects"
    />
  </div>
</template>

<script>
import ProjectActionButton from './Components/ProjectActionButton.vue'
import ProjectFormModal from './Components/ProjectFormModal.vue'

export default {
  name: 'AppProjects',
  components: { ProjectActionButton, ProjectFormModal },
  data() {
    return {
      projects: { data: [], current_page: 1, last_page: 1 },
      isModalActive: false,
      selectedProject: null,
      search: '',
      filterPlan: ''
    }
  },
  mounted() {
    this.fetchProjects()
  },
  computed: {
    totalPages() {
      let pages = []
      for (let i = 1; i <= this.projects.last_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    fetchProjects(page = 1) {
      axios.get('/projects', {
        params: {
          search: this.search,
          available_subscription_plan: this.filterPlan,
          per_page: 10,
          page: page
        }
      }).then(res => { this.projects = res.data })
    },
    changePage(page) {
      if (page < 1 || page > this.projects.last_page) return
      this.fetchProjects(page)
    },
    openModal() {
      this.selectedProject = null
      this.isModalActive = true
    },
    editProject(project) {
      this.selectedProject = project
      this.isModalActive = true
    },
    deleteProject(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This will permanently delete this project.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`/projects/${id}`).then(() => {
            this.fetchProjects(this.projects.current_page)
            Swal.fire({
              title: 'Deleted!',
              text: 'Project record has been deleted.',
              icon: 'success',
              confirmButtonColor: '#3085d6'
            })
          })
        }
      })
    }
  }
}
</script>

<style>
.pagination .page-item.disabled .page-link {
  pointer-events: none;
  opacity: 0.5;
}
.pagination .page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}
</style>

